import { PipeTransform, Pipe } from '@angular/core';

@Pipe({name: 'keyValue'})
export class KeyValuePipe implements PipeTransform {
  transform(obj): any {
    return Object.keys(obj).map(key => ({key, value: obj[key]}));
  }
}
